import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "minusplusnumber"
  }, [_c("div", {
    staticClass: "mpbtn minus",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.mpminus();
      }
    }
  }, [_vm._v("-")]), _c(VTextField, {
    staticClass: "mt-0 pt-0",
    attrs: {
      type: "number",
      value: _vm.newValue,
      "hide-details": "auto"
    },
    on: {
      input: _vm.mpm,
      click: function click($event) {
        $event.stopPropagation();
      }
    }
  }), _c("div", {
    staticClass: "mpbtn plus",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.mpplus();
      }
    }
  }, [_vm._v("+")])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };